import * as geojson from 'geojson';

import {AgentNoteImage} from './NotePreview';

export type AgentResponse = {
  type: 'step' | 'text' | 'output' | 'note';
  label: string;
  step: string;

  //TODO(eva): replace label with this
  text?: string;

  //TODO(eva): fork this type basased on type, maybe make AgentResponse<T>
  sourceId?: string;
  layerId?: string;
  sensingTime?: string;
  geometry?: null | geojson.Geometry;
  imageUrl?: string;
  error?: string;
  before_image?: AgentNoteImage;
  after_image?: AgentNoteImage;
};

export const parseAgentResponse = (response: string): AgentResponse[] => {
  return [JSON.parse(response)];
};
